<div class="login-wrap {{ documentDirection }}" *ngIf="isFormInit && socialsProvidersInit">

    <serviceos-ng-alert class="error-alert" *ngIf="formErrorMessage" [type]="'error'">
        {{ formErrorMessage }}
    </serviceos-ng-alert>

    <div class="social-providers-holder" *ngIf="socialProviders?.length">
        <ul class="social-list">
            <li class="social-item" *ngFor="let social of socialProviders; let  i = index">

                <div class="divider-line before" *ngIf="social?.type === 'Email' && i === socialProviders.length - 1 && socialProviders.length > 1">
                    <span *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.word_or ? moduleAuthTexts.word_or : 'or'}}</span>
                </div>

                <div *ngIf="social?.type === 'Email'" class="login-form-wrapper">
                    <div class="login-form-holder">
                        <serviceos-ng-local-loader [showLoader]="showLocalLoader"></serviceos-ng-local-loader>
                        <form #f="ngForm" [formGroup]="loginForm" novalidate (ngSubmit)="validateForm()">
                            <div class="form-fields-holder" [ngClass]="{'expand' : emailFormExpand }">
                                <div class="input-holder">
                                    <serviceos-ng-form-field>
                                        <serviceos-ng-label *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.email_field_label ? moduleAuthTexts.email_field_label : componentSettings.form.fields.email.textFieldSettings.label }}</serviceos-ng-label>
                                        <input
                                            [serviceosNgInput]="email?.value"
                                            [error]="
                                            email?.invalid && formSubmitted
                                            "
                                            type="text"
                                            id="email"
                                            name="email"
                                            formControlName="email"
                                            autocomplete="username"
                                        />
                                        <serviceos-ng-error-message>
                                            <ng-container *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
                                                {{ moduleAuthTexts.email_field_error ? moduleAuthTexts.email_field_error : componentSettings.form.fields.email.textFieldSettings.errMsg }}
                                            </ng-container>
                                        </serviceos-ng-error-message>
                                    </serviceos-ng-form-field>
                                </div>
                
                                <div class="input-holder">
                                    <serviceos-ng-form-field>
                                        <serviceos-ng-label *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.password_field_label ? moduleAuthTexts.password_field_label : componentSettings.form.fields.password.textFieldSettings.label }}</serviceos-ng-label>
                                        <input
                                            [serviceosNgInput]="password?.value"
                                            [error]="
                                            password?.invalid && formSubmitted
                                            "
                                            type="password"
                                            id="password"
                                            name="password"
                                            formControlName="password"
                                            autocomplete="current-password"
                                        />
                                        <serviceos-ng-error-message *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.password_field_error ? moduleAuthTexts.password_field_error : componentSettings.form.fields.password.textFieldSettings.errMsg }}</serviceos-ng-error-message>
                                    </serviceos-ng-form-field>
                                </div>
                
                                <div class="input-holder checkbox-holder">
                                    <input id="loggedIn" type="checkbox" name="loggedIn" formControlName="loggedIn" />
                                    <label for="loggedIn" *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
                                        <span class="obf-checkbox icon-si-check"></span>
                                        {{ moduleAuthTexts.login_checkbox_label ? moduleAuthTexts.login_checkbox_label : componentSettings.form.fields.loggedIn.textFieldSettings.label }}
                                    </label>
                                </div>

                                <div class="reset-password-holder">
                                    <span (click)="resetPasswordHandler('forgot-password')" *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.reset_password_label ? moduleAuthTexts.reset_password_label : componentSettings?.form?.navLinks?.resetPassword?.label }}</span>
                                </div>
                            </div>
                
                            <div class="btn-wrap">
                                <serviceos-ng-button
                                    id="login-button-component"
                                    [isSubmitButton]="true"
                                    [type]="'primary'"
                                    [isFullWidth]="true"
                                    *ngIf="moduleAuthTexts$ | async as moduleAuthTexts"
                                    >
                                    {{ moduleAuthTexts.login_button_label ? moduleAuthTexts.login_button_label : componentSettings?.form?.fields?.login?.label }}
                                </serviceos-ng-button>
                            </div>
                        </form>
                    </div>
                </div>

                <div class="divider-line after" *ngIf="social?.type === 'Email' && i === 0 && socialProviders.length > 1">
                    <span *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.word_or ? moduleAuthTexts.word_or : 'or'}}</span>
                </div>

                <serviceos-ng-button
                    *ngIf="social.type !== 'Email'"
                    (click)="loginSocial(social)"
                    [isFullWidth]="true"
                    [socialAction]="'login'"
                    [type]="social.type"
                    >
                </serviceos-ng-button>
            </li>
        </ul>

        <div class="divider-line" *ngIf="socialProviders.length && !hasEmailSocialLogin()">
            <span *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.word_or ? moduleAuthTexts.word_or : 'or'}}</span>
        </div>
    </div>
    <div class="login-form-holder" *ngIf="!hasEmailSocialLogin()">
        <serviceos-ng-local-loader [showLoader]="showLocalLoader"></serviceos-ng-local-loader>
        <form #f="ngForm" [formGroup]="loginForm" novalidate (ngSubmit)="validateForm()">
            <div class="form-fields-holder" [ngClass]="{'expand' : isFormExpand }">
                <div class="input-holder">
                    <serviceos-ng-form-field>
                        <serviceos-ng-label *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.email_field_label ? moduleAuthTexts.email_field_label : componentSettings.form.fields.email.textFieldSettings.label }}</serviceos-ng-label>
                        <input
                            [serviceosNgInput]="email?.value"
                            [error]="
                            email?.invalid && formSubmitted
                            "
                            type="text"
                            id="email"
                            name="email"
                            formControlName="email"
                            autocomplete="username"
                        />
                        <serviceos-ng-error-message>
                            <ng-container *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
                                {{ moduleAuthTexts.email_field_error ? moduleAuthTexts.email_field_error : componentSettings.form.fields.email.textFieldSettings.errMsg }}
                            </ng-container>
                        </serviceos-ng-error-message>
                    </serviceos-ng-form-field>
                </div>

                <div class="input-holder">
                    <serviceos-ng-form-field>
                        <serviceos-ng-label *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.password_field_label ? moduleAuthTexts.password_field_label : componentSettings.form.fields.password.textFieldSettings.label }}</serviceos-ng-label>
                        <input
                            [serviceosNgInput]="password?.value"
                            [error]="
                            password?.invalid && formSubmitted
                            "
                            type="password"
                            id="password"
                            name="password"
                            formControlName="password"
                            autocomplete="current-password"
                        />
                        <serviceos-ng-error-message *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.password_field_error ? moduleAuthTexts.password_field_error : componentSettings.form.fields.password.textFieldSettings.errMsg }}</serviceos-ng-error-message>
                    </serviceos-ng-form-field>
                    <!-- <div
                        class="obf-check"
                        (click)="
                            componentSettings.form.fields.password.textFieldSettings.showPassword = !componentSettings.form.fields.password
                                .textFieldSettings.showPassword
                        "
                    >   
                            <i class="obf-icon icon-si-eye" aria-hidden="true" *ngIf="componentSettings.form.fields.password.textFieldSettings.showPassword"></i>   
                            <i class="obf-icon icon-si-crossed-eye" aria-hidden="true" *ngIf="!componentSettings.form.fields.password.textFieldSettings.showPassword"></i>
                    </div> -->
                </div>

                <div class="input-holder checkbox-holder">
                    <!-- <serviceos-ng-checkbox>{{ componentSettings.form.fields.loggedIn.textFieldSettings.label }}</serviceos-ng-checkbox> -->
                    <input id="loggedIn" type="checkbox" name="loggedIn" formControlName="loggedIn" />
                    <label for="loggedIn" *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
                        <span class="obf-checkbox icon-si-check"></span>
                        {{ moduleAuthTexts.login_checkbox_label ? moduleAuthTexts.login_checkbox_label : componentSettings.form.fields.loggedIn.textFieldSettings.label }}
                    </label>
                </div>
            </div>

            <div class="btn-wrap">
                <serviceos-ng-button
                    id="login-button-component"
                    [isSubmitButton]="true"
                    [type]="'primary'"
                    [isFullWidth]="true"
                    *ngIf="moduleAuthTexts$ | async as moduleAuthTexts"
                    >
                    {{ moduleAuthTexts.login_button_label ? moduleAuthTexts.login_button_label : componentSettings?.form?.fields?.login?.label }}
                </serviceos-ng-button>
            </div>
        </form>

        <div class="reset-password-holder">
            <span (click)="resetPasswordHandler('forgot-password')" *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.reset_password_label ? moduleAuthTexts.reset_password_label : componentSettings?.form?.navLinks?.resetPassword?.label }}</span>
        </div>
    </div>
</div>
<div class="local-loader-box" *ngIf="!(isFormInit && socialsProvidersInit)">
    <serviceos-ng-local-loader [showLoader]="true"></serviceos-ng-local-loader>
</div>
